import { useQuery } from "@tanstack/react-query";
import {
  EuTaxonomyCompanyActivityCompaniesDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EU_TAXONOMY_ACTIVITY } from "../domain";

import { euTaxonomyCompanyActivityApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_COMPANY_ACTIVITY_COMPANIES =
  "GET_GET_COMPANY_ACTIVITY_COMPANIES";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getCompanyActivityCompanies = async (
  year?: string,
): Promise<EuTaxonomyCompanyActivityCompaniesDto> => {
  const response =
    await euTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivityCompanies(
      year,
    );

  return response.data;
};

export const useGetCompanyActivityCompanies = (
  user: UserProfileDto | null,
  year?: string,
): {
  companyActivityCompanies?: EuTaxonomyCompanyActivityCompaniesDto;
  companyActivityCompaniesEnabled: boolean;
  isSuccessGetCompanyActivityCompanies: boolean;
  isLoadingGetCompanyActivityCompanies: boolean;
  refetchCompanyActivityCompanies: () => void;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isSuccess, isLoading, refetch } = useQuery({
    queryKey: [
      DOMAIN_EU_TAXONOMY_ACTIVITY,
      ACTION_GET_COMPANY_ACTIVITY_COMPANIES,
      year ?? "no-year",
    ],
    queryFn: () => getCompanyActivityCompanies(year),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    companyActivityCompanies: data,
    companyActivityCompaniesEnabled: enabled,
    isSuccessGetCompanyActivityCompanies: isSuccess,
    isLoadingGetCompanyActivityCompanies: isLoading,
    refetchCompanyActivityCompanies: refetch,
  };
};
